<template>
  <v-container fluid>

    <div class="p-4 ma-3">
      <h2 class="mb-5">Add transition-group</h2>
    </div>

    <v-card class="pa-5 ma-3 rounded-0">
      <v-card-title>
        <v-row>
          <v-col>
            <h4>Tags</h4>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-row class="mb-4" style="margin-top: -26px;">
          <v-col>
            <h5>To help you manage your certificates, you can optionally No tags
              associated with this resource.Add tag You can add 50 more tags</h5>
          </v-col>
        </v-row>

        <v-row v-if="notag">
          <v-col>
            <h4>No tags associated with this resource.</h4>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col>
            <v-row v-for="(tagSet, index) in tags" :key="index">
              <v-col>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card-text style="margin-left: -30px;">
                        <h3>Tag Key</h3>
                        <!--search-->
                        <v-text-field class="mt-0" v-model="tagSet.key" append-icon="mdi-magnify" label="Enter Key"
                          single-line hide-details color="black"></v-text-field>
                      </v-card-text>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-card-text style="margin-left: -30px;">
                        <h3>Tag value - optional</h3>
                        <!--search-->
                        <v-text-field class="mt-0" v-model="tagSet.value" append-icon="mdi-magnify" label="Enter value"
                          single-line hide-details color="black"></v-text-field>
                      </v-card-text>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-card-text style="margin-left: -30px; margin-top: 26px;">
                        <v-btn elevation="0" outlined @click="removeTag(index)">
                          Remove Tags
                        </v-btn>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
            <v-btn elevation="0" outlined @click="addTag">
              Add Tag
            </v-btn>
          </v-col>
        </v-row>
        <v-row style="margin-top: -14px;">
          <v-col>
            <h4>You can add 50 more tag(s).</h4>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row justify="end" class="bg-purple mt-3 mr-0">
      <v-col v-for="count in 1" :key="count" cols="auto">
        <v-btn elevation="0" outlined class="mr-2">
          Cancel
        </v-btn>
        <v-btn elevation="0" outlined class="mr-2">
          Previous
        </v-btn>
        <v-btn dark elevation="0" @click="goToReviewPage">
          Next
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped></style>